import { gql } from '__generated__';

export default gql(`
  mutation AddParticipantField($input: AddParticipantFieldInput!) {
    addParticipantField(input: $input) {
      id
    }
  }
`);
